<template>
	<!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单记录
  -->
	<div class="pb50" v-loading="loading">
		<div class="product-content">
			<!--基本信息-->
			<div class="table-wrap">
				<el-timeline>
					<el-timeline-item
					v-for="(activity, index) in activities"
					:key="index"
					:timestamp="activity.timestamp">
					{{activity.content}}
					</el-timeline-item>
				</el-timeline>
			</div>		
		</div>
		
	</div>
</template>

<script>
	import OrderApi from '@/api/order.js';
	import {
		deepClone,
	} from '@/utils/base.js';
	export default {
		
		data() {
			return {
				/*是否加载完成*/
				loading: true,
				activities: [
					{
						content: '用户下单',
						timestamp: '2023-08-30 20:20:00'
					}, 
					{
						content: '接单（待出发）',
						timestamp: '2023-08-30 20:21:00'
					}, 
					{
						content: '出发',
						timestamp: '2023-08-30 20:22:00'
					},
					{
						content: '到达',
						timestamp: '2023-08-30 20:32:00'
					},
					{
						content: '进行中',
						timestamp: '2023-08-30 20:42:00'
					},
					{
						content: '完成',
						timestamp: '2023-08-30 21:22:00'
					},
					{
						content: '评价',
						timestamp: ''
					}
				]
			}
		},
		created(e) {
			/*获取列表*/
			this.getParams();
		},
		methods: {			
			/*获取参数*/
			getParams() {
				let self = this;
				// 取到路由带过来的参数
				const params = this.$route.query.orderId;
				OrderApi.orderdetail({
							orderId: params
						},
						true
					)
					.then(data => {
						self.loading = false;
					})
					.catch(error => {
						self.loading = false;
					});
			}
		}
	};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/part/record.vue